import PropTypes from 'prop-types';
import cx from 'classnames';

import withTheme from 'core/hocs/withTheme';
import themePropTypes from 'core/utils/prop-types/theme';

import { getCountPairs } from '../utils';

import Check from 'core/components/Icon/Check.svg';

import types from './types';

import styles from './index.styl';


// Стили вынесены в style jsx для amp страниц
function Progressbar(props) {
  const {
    theme: {
      controls: {
        gameCompare: {
          progressbar: progressbarAtoms,
          compareCard: compareCardAtoms,
        },
      },
    },
    progress,
    showOver,
    showEmpty,
    progressText,
    progressInside,
    type,
    allRounds,
  } = props;

  const {
    vs: Vs,
  } = progressbarAtoms;

  const {
    size,
    beforeSize,
    afterSize,
    iconWidth,
    compareCard,
  } = types[type];

  const atoms = compareCard ? compareCardAtoms.progressbar : progressbarAtoms;
  const prevProgress = (progress !== 0 && allRounds) ? progress - (100 / getCountPairs(allRounds))
    : 0;
  const stepProgress = (progress - prevProgress) / 2;

  return (
    <div
      className={cx(
        'progressbar',
        progressText && styles._withText,
        progressInside && '_inner',
        allRounds ? '_animateProgress' : '_withoutAnimate')}
    >
      <style jsx>{`
        .progressbar
          display flex
          justify-content center
          align-items center
          flex-direction column
          position relative
          border-radius 50%
          width ${size}px
          height ${size}px
          background conic-gradient(${atoms.progressColor}, ${3.6 * prevProgress}deg, ${atoms.strokeColor} 0deg)
          &._animateProgress
            animation animate 300ms ease-out 150ms forwards
          &._withoutAnimate
            background conic-gradient(${atoms.progressColor}, ${3.6 * progress}deg, ${atoms.strokeColor} 0deg)
          &:before
            content ''
            position absolute
            border-radius 50%
            background ${atoms.background}
            width ${beforeSize}px
            height ${beforeSize}px
          &:after
            content ''
            position absolute
            border-radius 50%
            z-index -1
          &._inner:after
            background ${atoms.background}
            width ${afterSize}px
            height ${afterSize}px

        @keyframes animate {
          0% {
            background conic-gradient(${atoms.progressColor}, ${3.6 * (prevProgress + stepProgress)}deg, ${atoms.strokeColor} 0deg)
          }
          50% {
            background conic-gradient(${atoms.progressColor}, ${3.6 * (stepProgress * 2 + prevProgress)}deg, ${atoms.strokeColor} 0deg)
          }
          100% {
            background conic-gradient(${atoms.progressColor}, ${3.6 * progress}deg, ${atoms.strokeColor} 0deg)
          }
        }
        .${styles.text}
          font ${progressbarAtoms.font}
          color ${progressbarAtoms.textColor}

        .icon
          display flex
          z-index 1
          ._withText &
            margin-top 10px
      `}</style>
      <div className='icon'>
        {showOver && !showEmpty && (
          <div className={styles.check}>
            <Check fill={atoms.iconFill} />
          </div>
        )}
        {!showOver && !showEmpty && (
          <Vs
            fill={atoms.iconFill}
            height={28}
            {...iconWidth && { width: iconWidth }}
          />
        )}
      </div>
      {progressText &&
        <div className={styles.text}>
          {showOver || showEmpty ? '' : progressText}
        </div>
      }
    </div>
  );
}

Progressbar.propTypes = {
  theme: themePropTypes(`
    {
      controls: {
        gameCompare: {
          progressbar: {
            strokeColor,
            textColor,
            iconFill,
            progressColor,
            background,
            font,
          }
        },
      },
    }
  `),
  progress: PropTypes.number,
  /**
    * Vs либо галочка
  */
  showOver: PropTypes.bool,
  /**
    * Не показываем ничего
  */
  showEmpty: PropTypes.bool,
  progressText: PropTypes.string,

  /**
    * Линия прогресса внутри круга
  */
  progressInside: PropTypes.bool,
  type: PropTypes.number,
  allRounds: PropTypes.object,
};

Progressbar.defaultProps = {
  progress: 0,
};

export default withTheme(Progressbar);
